import clsx from 'clsx';

type DialogFooterProps = React.PropsWithChildren<{
	className?: string;
}>;

export function DialogFooter({ className, children }: DialogFooterProps) {
	const cl = clsx(className, 'flex border-t border-gray-5 p-4');
	return <div className={cl}>{children}</div>;
}
